import React from 'react';
import { Filter } from './search_filters';
import { Location } from 'history';
import DismissibleCategoryFilter from './dismissible_category_filter';
import DismissibleRangeFilter from './dismissible_range_filter';
import DismissibleFilter from './dismissible_filter';
import { selectedPath } from '../facet_utils';

interface IProps {
  filter: Filter;
  location: Location;
}

export default function DismissibleFilterGroup({
  filter,
  location = null,
}: IProps) {
  let selectedOptions = [];

  if (filter.aggregationName === 'CATEGORY_SLUGS') {
    // selectedPath() returns an array of FacetOptions from the root to the node that is selected
    // so for example, if we have a leaf subcategory selected, that will be the last entry returned
    selectedOptions.push(selectedPath(filter).pop());
  } else if (filter.widgetType === 'RANGE') {
    selectedOptions.push(filter.options[2]);
  } else if (filter.options) {
    selectedOptions = filter.options.filter(o => {
      return o.selected;
    });
  }

  return (
    <>
      <span className="filter-chip__group-title">{`${filter.name}:`}</span>

      {selectedOptions.map(option => {
        if (filter.aggregationName === 'CATEGORY_SLUGS') {
          return (
            <DismissibleCategoryFilter
              filter={filter}
              option={option}
              location={location}
              key={filter.name}
            />
          );
        }

        if (filter.widgetType === 'RANGE') {
          return (
            <DismissibleRangeFilter
              filter={filter}
              option={option}
              location={location}
              key={filter.name}
            />
          );
        }

        return (
          <DismissibleFilter
            filter={filter}
            option={option}
            location={location}
            key={filter.name}
          />
        );
      })}
    </>
  );
}
